;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('customField', customField)

  function customField () {
    return function (value) {
      if (typeof (value) === 'boolean') {
        return value ? 'Vrai' : 'Faux'
      }
      if (typeof (value) === 'date') {
        return moment(value).format('dddd DD MMMM YYYY')
      }
      if (/\b[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z\b/.test(value)) {
        var d = moment(new Date(value))
        return d.format('dddd DD MMMM YYYY')
      }
      if (_.isArray(value)) {
        return '' + value.length + ' fichier' + (value.length > 1 ? 's' : '')
      }
      if (_.isNil(value)) {
        return ' - '
      }
      return value
    }
  }
})(window.angular, window.moment, window._)
